import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Loader2 } from "lucide-react";
import ReactMarkdown from "react-markdown";

const TermsAndConditions = () => {
  const [title, setTitle] = useState("Terms & Conditions");
  const [body, setBody] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    supabase
      .from("site_content")
      .select("*")
      .eq("content_key", "terms_and_conditions")
      .single()
      .then(({ data }) => {
        if (data) {
          setTitle(data.title);
          setBody(data.body);
        }
        setIsLoading(false);
      });
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-[100dvh] bg-background flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-12 max-w-3xl">
      <h1 className="font-display text-3xl font-bold text-foreground mb-8">
        {title}
      </h1>
      <div className="prose prose-sm max-w-none">
        <ReactMarkdown
          components={{
            h2: ({ children }) => (
              <h2 className="font-display text-xl font-bold text-foreground mt-8 mb-4">
                {children}
              </h2>
            ),
            h3: ({ children }) => (
              <h3 className="font-display text-lg font-semibold text-foreground mt-6 mb-3">
                {children}
              </h3>
            ),
            p: ({ children }) => (
              <p className="text-muted-foreground font-body leading-relaxed mb-4">
                {children}
              </p>
            ),
            li: ({ children }) => (
              <li className="ml-4 text-muted-foreground font-body leading-relaxed">
                {children}
              </li>
            ),
            ul: ({ children }) => (
              <ul className="list-disc mb-4">{children}</ul>
            ),
            strong: ({ children }) => (
              <strong className="text-foreground">{children}</strong>
            ),
          }}
        >
          {body}
        </ReactMarkdown>
      </div>
    </div>
  );
};

export default TermsAndConditions;
